import { IUISupplier } from '@bridebook/toolbox/src/types';
import { IElasticSupplier } from '@bridebook/web/lib/supplier/types';

/**
 * See required fields of the schema:
 * https://schema.org/LocalBusiness
 * https://schema.org/AggregateRating
 *
 * Schema validator: https://developers.google.com/search/docs/advanced/structured-data
 * Jira: https://bridebook.atlassian.net/browse/LIVE-13694
 */
interface IMicroData {
  '@context': 'https://schema.org';
  '@type': 'LocalBusiness';
  logo: string;
  url: string;
  name: string;
  image: string;
  address: {
    '@type': 'PostalAddress';
    streetAddress: string;
    postalCode?: string;
    addressLocality: string;
    addressRegion: string;
    addressCountry: string;
  };
  aggregateRating?: {
    '@type': 'AggregateRating';
    reviewCount: number;
    ratingValue: number;
    worstRating: number;
    bestRating: number;
  };
}

const getAddress = (supplier: IElasticSupplier): IMicroData['address'] => {
  const streetAddress = supplier?.street || '';
  const postalCode = supplier?.postalCode || '';
  const addressLocality = supplier?.town || '';
  const addressRegion = supplier?.county || '';
  const addressCountry = supplier?.countryCode || '';

  return {
    '@type': 'PostalAddress',
    streetAddress,
    postalCode,
    addressLocality,
    addressRegion,
    addressCountry,
  };
};

export const generateSearchResultItemMicrodata = (
  item: IUISupplier,
  logo: string,
  url: string,
): IMicroData => {
  const { name, reviewsCount: reviewCount, reviewsStars: ratingValue } = item;

  const itemData: IMicroData = {
    '@context': 'https://schema.org',
    '@type': 'LocalBusiness',
    logo,
    url,
    name,
    image: logo,
    address: getAddress(item),
  };

  if (reviewCount && reviewCount > 0 && ratingValue && ratingValue > 0) {
    itemData.aggregateRating = {
      '@type': 'AggregateRating',
      reviewCount,
      ratingValue,
      bestRating: 5,
      worstRating: 1,
    };
  }

  return itemData;
};
